export default __webpack_public_path__ + "static/media/ipod-shuffle.4d792a51.png";